import { render } from "./select-account-type.vue?vue&type=template&id=065dd503&scoped=true"
import script from "./select-account-type.vue?vue&type=script&lang=js"
export * from "./select-account-type.vue?vue&type=script&lang=js"

import "./select-account-type.vue?vue&type=style&index=0&id=065dd503&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065dd503"]])

export default __exports__